import {Injectable} from '@angular/core';
import {HttpClientService} from './http-client.service';
import {Subscription} from 'rxjs';

declare let iNet: any;

@Injectable()
export class SuggestionService {
    static instance: SuggestionService = null;  // Create a singleton service

    constructor(private http: HttpClientService) {
        return SuggestionService.instance = SuggestionService.instance || this;
    }

    saveSuggestion(params: SuggestionParamData, callback?: Function): Subscription {
        if (!params.keyword) {
            return;
        }
        return this.http.postJSON(iNet.getPUrl('system/suggestion/update'), params).subscribe(
            (data) => {
                if (callback) {
                    callback(data);
                }
            },
            (err) => {
                if (callback) {
                    callback(null, err);
                }
            }
        );
    }

    loadSuggestion(params: SuggestionParamData, callback: Function): Subscription {
        return this.http.postJSON(iNet.getPUrl('system/suggestion/hint'), params).subscribe(
            (data: SuggestionResponse) => {
                callback(data && data.items || []);
            },
            err => {
                callback([], err);
            }
        );
    }
}
export interface SuggestionParamData {
    content: string;
    keyword: string;
}

export interface SuggestionResponse {
    items: SuggestionItem[];
    total: number;
}

export interface SuggestionItem {
    content: string;
    keyword: string;
    ownercode: string;
    usage: number;
    uuid: string;
}
